const Registration = () => {
	return null;
};

export default Registration;
